// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "content_attempt".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "content_attempt" table (1:1 with a DB row, on the wire). */
export const contentAttemptAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    slotId: z.string(),
    batchId: z.string().nullable(),
    attemptNumber: z.number(),
    videoId: z.string().nullable(),
    graphicId: z.string().nullable(),
    approvedAt: z.string().datetime().nullable(),
    caption: z.string().nullable(),
    pendingVideoEdits: z.unknown().nullable(),
    editRenderCount: z.number(),
    regenerationReason: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=contentAttempt.js.map